import { Toggle } from '@components/form';
import { useContext } from 'react';
import { ToggleThemeMode, getThemeMode } from './Theme';

export const ThemeToggle = () => {
  const toggleTheme = useContext(ToggleThemeMode);
  const mode = getThemeMode();
  return <Toggle checked={mode === 'dark'} onChange={toggleTheme} />;
};
